import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-contact-results',
  props: {
  /**
   * An array containing the search results for contacts.
   * Each item in the array represents a contact found during the search.
   * @type {ContactFindResult[]}
   * @required
   */
  data: {
    type: Array as PropType<ContactFindResult[]>,
    required: true,
  },

  /**
   * Indicates whether a search operation is currently in progress.
   * @type {boolean}
   * @default false
   */
  searching: {
    type: Boolean,
    default: false,
  },
  /**
   * The field name which will be used to disable contacts from grid.
   * @type {string}
   * @default ''
   */
  restrictedFieldName: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emits an event when a row is clicked.
   * Passes the selected contact data to the parent component.
   * @param {ContactFindResult} e - The clicked row's contact data.
   */
  "rowClick",
  /**
   * Emits an event when a row is selected.
   * Sends both the contact data and the row index to the parent component.
   * @param {ContactFindResult} e - The selected row's contact data.
   * @param {number} rowIndex - The index of the selected row.
   */
  "rowSelected",
  /**
   * Emits an event when a row is selected adaptively.
   * This can be used for dynamic selection behavior in the UI.
   * @param {ContactFindResult} e - The adaptively selected row's contact data.
   */
  "adaptiveRowSelection",
],
  setup(__props, { emit }) {





/** Handles the grid row click event */
const onRowClick = (e: ContactFindResult) => emit("rowClick", e);

/** Handles the grid row selected event */
const onRowSelected = (e: ContactFindResult, rowIndex: number) => {
  emit("rowSelected", e, rowIndex);
};

// Handles the event triggered when the user clicks on the ... button on a row
const adaptiveRowSelection = (e: ContactFindResult) =>
  emit("adaptiveRowSelection", e);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridBase, {
    "data-source": __props.data,
    "id-column-name": "id",
    loading: __props.searching,
    "show-column-filters": false,
    "show-search-panel": false,
    "word-wrap-enabled": true,
    onRowClick: onRowClick,
    onRowSelected: onRowSelected,
    onAdaptiveRowSelection: adaptiveRowSelection,
    "restricted-field-name": __props.restrictedFieldName
  }, {
    columns: _withCtx(() => [
      _createVNode(_unref(DxColumn), {
        "data-field": "name",
        caption: "Name",
        width: "270px",
        "hiding-priority": 9
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "type.description",
        caption: "Type",
        "hiding-priority": 8
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "status.description",
        caption: "Status",
        "hiding-priority": 7
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "address",
        caption: "Address",
        "hiding-priority": 6,
        width: "200"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "telephoneNumber",
        caption: "Telephone",
        "hiding-priority": 5
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "mobileNumber",
        caption: "Mobile",
        "hiding-priority": 4
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "emailAddress",
        caption: "Email",
        "hiding-priority": 3
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        caption: "ID",
        "hiding-priority": 2
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "altReference",
        caption: "Alt. Reference",
        "hiding-priority": 1
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "isRestricted",
        visible: false
      })
    ]),
    _: 1
  }, 8, ["data-source", "loading", "restricted-field-name"]))
}
}

})